import { render, staticRenderFns } from "./SelectQuantitiesStory.vue?vue&type=template&id=cf6a2c78&"
import script from "./SelectQuantitiesStory.vue?vue&type=script&lang=ts&"
export * from "./SelectQuantitiesStory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports